import type { RouteRecordRaw } from 'vue-router'
import AuthRoutes from './modules/auth'
import ErrorRoutes from './modules/error'
import { PendingRoutes, ReceiverRoutes, SenderRoutes } from './modules/move-order'
import PasswordRoutes from './modules/password'
import PrintRoutes from './modules/print'
import ProductRoutes from './modules/product'
import SaleRoutes from './modules/sale'
import SaleDeprecatedRoutes from './modules/sale-deprecated'
import StockAdjustmentRoutes from './modules/stock-adjustment'

const routes: RouteRecordRaw[] = [

  layoutApp('/home', [
    {
      path: '/riwayat-perubahan',
      name: 'changelogs',
      component: () => import('@/views/app/changelog/page-list.vue'),
      meta: { title: 'Riwayat Perubahan' },
    },
    {
      path: '/css',
      name: 'css',
      component: () => import('@/views/app/css/page-index.vue'),
      meta: { title: 'CSS' },
    },
    {
      path: '/',
      name: 'new sale',
      component: () => import('@/views/app/cashier/page-index.vue'),
      meta: { title: 'Kasir' },
    },
    {
      path: '/penjualan-tukar-varian',
      name: 'sale exchange variant',
      component: () => import('@/views/app/sale/exchange-variant/page-list.vue'),
      meta: { title: 'Tukar Warna/Ukuran' },
    },
  ]),
  layoutApp('/pengiriman', SenderRoutes),
  layoutApp('/penerimaan', ReceiverRoutes),
  layoutApp('/mutasi/pending', PendingRoutes),
  layoutApp('/produk', ProductRoutes),
  layoutApp('/transaksi', SaleDeprecatedRoutes),
  layoutApp('/penjualan', SaleRoutes),
  layoutApp('/penyesuaian-stok', StockAdjustmentRoutes),
  layoutApp('/ubah-password', PasswordRoutes),
  PrintRoutes,
  AuthRoutes,
  ErrorRoutes,
  {
    path: '/akses-ditolak',
    name: 'forbidden',
    component: () => import('@/views/errors/error-403.vue'),
    meta: { title: 'Akses Ditolak' },
  },
]

export function layoutApp (path: string, children: RouteRecordRaw[]): RouteRecordRaw {
  return {
    path,
    children,
    component: () => import('@/views/app/the-layout.vue'),
  }
}

export default routes
